import grispiEndUserApi from '../../apis/grispiEndUserApi';

export const createEndUserRequest = async (formdata: FormData): Promise<string> => {
    const response = await grispiEndUserApi.post(`/user-forms/tickets`, formdata);
    return response.data;
};
